<template>
  <div class="flex flex-row justify-center">
    <ButtonContentSection
      :label="content"
      :icon="ArrowRight"
      @click="() => clickTeaser(contentSection.articleId)"
    />
  </div>
</template>

<script lang="ts" setup>
import { useRouter, useRoute } from "vue-router";
import ButtonContentSection from "../layout/button/ButtonContentSection.vue";
import ArrowRight from "../icon/ArrowRight.vue";

interface ContentSection {
  [key: string]: any;
}

defineProps<{
  categoryName?: string;
  contentSection?: ContentSection;
  content?: string;
}>();

const router = useRouter();
const route = useRoute();

function clickTeaser(id: number) {
  router.push({
    name: "article",
    params: {
      slug: route.params.slug,
      id: id,
    },
  });
}
</script>
